import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

const HorizontalSpinner = props => {
    return <LinearProgress id='horizontalSpinner' size={40} color="primary" style={{width: '100%'}}/>
};

export default HorizontalSpinner;
